//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'page-layout-spacing',
    data: function(){
      return {
        borderside:['top','bottom']
      }
    }
};



// WEBPACK FOOTER //
// ./example/pages/layout-spacing.vue